import React, {useContext} from 'react'
import {CustomerContext} from '../CustomerContext'
import SettingsForm from './forms/SettingsForm'
import LockForm from './forms/LockForm'
import {Card} from '@/components/Card'

const Settings = () => {
  const { customer, refresh, settings } = useContext(CustomerContext)

  if (!customer) {
    return (<></>)
  }
  const status = customer.statuses.at(-1)

  return (
    <>
      <SettingsForm
        customerId={customer._id}
        settings={customer.settings}
        refreshCustomer={refresh}
        defaultLimits={settings.purchaseRestrictions.limits}
        maxMsisdn={settings.purchaseRestrictions.maxMsisdn}
        maxDevices={settings.purchaseRestrictions.maxDevices}
        maxIsp={settings.purchaseRestrictions.maxIsp}
        spent={customer.spent}
      />

      {status?.status !== 'STATUS_LOCKED' && (
        <Card
          className="card mb-5 mb-xl-10 mt-10"
          title="Lock this account"
          collapsable={true}
          collapse={true}
          id="lock-card"
        >
          <LockForm customerId={customer._id} refreshCustomer={refresh} status="LOCKED"/>
        </Card>
      )}

      {status?.status === 'STATUS_LOCKED' && (
        <Card
          className="card mb-5 mb-xl-10 mt-10"
          title="Unlock this account"
          collapsable={true}
          collapse={true}
          id="unlock-card"
        >
          <LockForm customerId={customer._id} refreshCustomer={refresh} status="VALIDATED"/>
        </Card>
      )}
    </>
  )
}

export default Settings
